import React from 'react'
import styled from 'styled-components'
import {mediaQueries, fonts} from "../shared/config"

const { titles } = fonts;

export default function SmallSubheader(props) {
    return (
        <Subheader>
            By {props.bylines}
        </Subheader>
    )
}

const Subheader = styled.h3`
    font-family: ${titles};
    font-style: normal;
    font-weight: bold;
    text-align: center;
    color: white;
    font-size: 24px;
    margin-top: 10px;
    ${mediaQueries.mobile} {
        font-size: 20px;
	}
`    
